export const toMovie = (id: number | string) => `/movies/${id}`;
export const toPerson = (id: number | string) => `/people/${id}`;

export const toMovies = () => "/movies";
export const toPeople = () => "/people";

export const toMoviesSearch = () => "/movies/search";
export const toPeopleSearch = () => "/people/search";
